// extracted by mini-css-extract-plugin
module.exports = {"StockScore":"StockScore_StockScore__Ev2Jn"};